export const COUNTRY_CONFIGS = [
  {
    name: "Kenya",
    code: "KE",
    dialCode: "+254",
    flag: "🇰🇪",
    placeholder: "712 345 678",
    length: 9,
    validationMessage: "Contact number must be exactly 9 digits",
  },
  {
    name: "Uganda",
    code: "UG",
    dialCode: "+256",
    flag: "🇺🇬",
    placeholder: "712 345 678",
    length: 9,
    validationMessage: "Contact number must be exactly 9 digits",
  },
  {
    name: "Tanzania",
    code: "TZ",
    dialCode: "+255",
    flag: "🇹🇿",
    placeholder: "712 345 678",
    length: 9,
    validationMessage: "Contact number must be exactly 9 digits",
  },
  {
    name: "Nigeria",
    code: "NG",
    dialCode: "+234",
    flag: "🇳🇬",
    placeholder: "0801 234 5678",
    length: 11,
    validationMessage: "Contact number must be exactly 11 digits",
  },
];

export const DEFAULT_COUNTRY = COUNTRY_CONFIGS[0];
